import * as Actions from '../../actions/medprocure/index';

const initialState = {
    authRoleList: []
};

const data = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_AUTH_ROLES:
        {
            return {
                ...state,
                authRoleList: action.payload
            };
        }
        default:
        {
            return state;
        }
    }
};

export default data;


// WEBPACK FOOTER //
// src/store/reducers/medprocure/data.reducer.js